import { render } from "./Expense.vue?vue&type=template&id=3016d398"
import script from "./Expense.vue?vue&type=script&lang=js"
export * from "./Expense.vue?vue&type=script&lang=js"
script.render = render

export default script